module.exports = __webpack_public_path__ + "img/item7.3bf013cb.png";